import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useMedia } from 'react-media-match';
import useConfig from '@empiriecom/module-components/hooks/useConfig';
import { FragmentConfiguration } from '@/config';
import { AttributeBlock, Availability } from '@/interfaces';
import AvailabilityMessage from '../AvailabilityMessage';
import DeliveryMessage from '../DeliveryMessage';
import ExpressServiceMessage from '../ExpressServiceMessage';
import Card, { CardHeadline } from '../../Card';
import SpecialHint from '../../SpecialHint';

type AvailabilityCardProps = {
  availability: Availability;
  deliveryAttribute?: AttributeBlock;
};

/** <p>This component combines the `AvailabilityMessage`, `DeliveryMessage` and `ExpressServiceMessage` components
 * into one component wrap with the `Card` layout component.</p>
 * <p>`availability` object and `deliveryType` need to be passed for correct display.</p>
 */
export const DeliveryCard: FC<AvailabilityCardProps> = ({ availability, deliveryAttribute }) => {
  let isCarrierDelvery = false;
  const { state, message, hasExpressService } = availability;
  const isMobile = useMedia({ desktop: false, mobile: true, tablet: false });
  const config: FragmentConfiguration = useConfig();
  if (deliveryAttribute) {
    const { values } = deliveryAttribute;
    const carrierAttribute = values.filter(({ type }) => type === 'speditionHint');
    isCarrierDelvery = carrierAttribute.length === 1;
  }
  return (
    <>
      {isMobile ? (
        <Card
          contentPadding
          headline={
            <CardHeadline>
              <FormattedMessage id="DeliveryCard.headline" defaultMessage="Lieferinformationen" />
            </CardHeadline>
          }
        >
          <AvailabilityMessage
            state={state}
            message={message}
            isCarrierDelivery={isCarrierDelvery}
          />
          <DeliveryMessage deliveryAttribute={deliveryAttribute} />
          <ExpressServiceMessage hasExpressService={hasExpressService} />
          {config.specialHint.enabled && <SpecialHint hasModal />}
        </Card>
      ) : (
        <>
          <AvailabilityMessage
            state={state}
            message={message}
            isCarrierDelivery={isCarrierDelvery}
          />
          <DeliveryMessage deliveryAttribute={deliveryAttribute} />
          <ExpressServiceMessage hasExpressService={hasExpressService} />
          {config.specialHint.enabled && <SpecialHint hasModal />}
        </>
      )}
    </>
  );
};

export default DeliveryCard;
